import { motion, AnimatePresence } from 'framer-motion';
import { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

// Now these imports should work because files are in the right place
import introVideo from '../assets/images/loading-intro.mp4';
import logoLight from '../assets/images/bqlo fon LOGO.webp';

const Preloader = ({ onComplete }) => {
  const { i18n } = useTranslation();
  const [phase, setPhase] = useState('checking');
  const [progress, setProgress] = useState(0);
  const videoRef = useRef(null);

  useEffect(() => {
    const videoShown = sessionStorage.getItem('introVideoShown');
    if (videoShown) {
      setPhase('logo');
    } else {
      setPhase('video');
    }
  }, []);

  const handleVideoEnd = () => {
    sessionStorage.setItem('introVideoShown', 'true');
    setPhase('logo');
  };

  const handleVideoError = (e) => {
    console.error('Video error:', e);
    sessionStorage.setItem('introVideoShown', 'true');
    setPhase('logo');
  };

  useEffect(() => {
    if (phase !== 'logo') return;

    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => onComplete(), 300);
          return 100;
        }
        return prev + 4;
      });
    }, 40);

    return () => clearInterval(timer);
  }, [phase, onComplete]);

  if (phase === 'checking') {
    return null;
  }

  return (
    <AnimatePresence mode="wait">
      {phase === 'video' && (
        <motion.div
          key="video"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[9999] bg-black flex items-center justify-center"
        >
          <video
            ref={videoRef}
            src={introVideo}
            autoPlay
            muted
            playsInline
            onEnded={handleVideoEnd}
            onError={handleVideoError}
            className="w-full h-full object-cover"
          />
          <motion.button
            type="button"
            onClick={() => {
              sessionStorage.setItem('introVideoShown', 'true');
              setPhase('logo');
            }}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.4 }}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
            className="absolute bottom-6 right-1/2 translate-x-1/2 sm:bottom-10 sm:right-10 sm:translate-x-0 inline-flex min-w-[180px] items-center justify-center gap-3 border-2 border-white/80 bg-[#0f1729]/80 px-8 py-4 font-heading text-base sm:text-lg font-bold uppercase tracking-[0.16em] text-white shadow-2xl backdrop-blur-md transition-colors hover:bg-white hover:text-[#0f1729] focus:outline-none focus-visible:ring-4 focus-visible:ring-white/50"
            aria-label={i18n.language === 'bg' ? 'Пропусни интрото' : 'Skip intro'}
          >
            <span>{i18n.language === 'bg' ? 'Пропусни' : 'Skip'}</span>
            <span aria-hidden="true" className="text-xl leading-none">→</span>
          </motion.button>
        </motion.div>
      )}

      {phase === 'logo' && (
        <motion.div
          key="logo"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-white"
        >
          <div className="text-center">
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="mb-8"
            >
              <img 
                src={logoLight} 
                alt="Nationals '94 Foundation" 
                className="w-48 h-48 mx-auto mb-6 object-contain"
                onError={(e) => console.error('Image error:', e)}
              />
              <h1 className="font-heading text-4xl font-bold text-[#0f1729] mb-2">
                Nationals '94
              </h1>
              <p className="font-body text-lg text-gray-500 tracking-widest">
                Foundation
              </p>
            </motion.div>
            <div className="w-64 h-1 bg-gray-200 rounded-full overflow-hidden mx-auto">
              <motion.div
                className="h-full bg-[#2d4a6f]"
                initial={{ width: 0 }}
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.1 }}
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;